<template lang="html">
    <div>
        <form @submit.prevent="addSocialProfile">
        <div class="form-group">
            <label for="vendor">Platform</label>
            <select class="form-control" name="vendor" v-model="form.vendor" @change="checkVendor()">
                <option :value="null">Select a Platform</option>
                <!-- <option value="Facebook">Facebook</option> -->
                <option value="Instagram">Instagram</option>
                <option value="LinkedIn">LinkedIn</option>
                <option value="Twitter">Twitter</option>
            </select>
        </div>
        <div class="form-group" v-if="form.vendor !== null">
          <label for="profile_id">Profile</label>

          <select class="form-control" name="profile_id" v-model="form.profile_id" v-if="form.vendor === 'Facebook'">
              <option value="null">Select a Page</option>
              <option v-for="facebook_page in facebook_pages" :value="facebook_page.id">{{facebook_page.name}}</option>
          </select>

          <input type="text" class="form-control" name="profile_id" v-model="form.profile_id" :placeholder="profileIdPlaceholder" v-else>
        </div>

        <div class="form-group" v-if="form.vendor === 'LinkedIn'">
          <label for="profile_id">Company Name</label>
          <input type="text" class="form-control" name="profile_id" v-model="form.profile_label" placeholder="Acme Inc.">
        </div>

        <div class="form-group" v-show="this.form.profile_id !== null">
            <button type="submit" class="btn btn-primary" :class="{'btn-loading': loading}" :disabled="loading">
                Add Profile
            </button>
        </div>
        </form>
    </div>
</template>

<script>

import { mapGetters } from 'vuex';

export default {
    data() {
        return {
            facebook_pages: [],

            form: {
                vendor: null,
                profile_id: null,
                profile_label: null,
                token_id: null,
                client_name: null,
            },

            loading: false
        }
    },

    computed: {
        ...mapGetters('client',{
            'client': 'activeClient',
            'isAdmin': 'isAdmin',
        }),

        profileIdPlaceholder() {
            switch (this.form.vendor) {
                case "Twitter":
                    return "Twitter Username (@Company)";
                case "Instagram":
                    return "Instagram Username";
                case "LinkedIn":
                    return "LinkedIn Company ID";
            }
        }
    },

    methods: {
        checkVendor() {
            if (this.form.vendor === 'Facebook') {
                this.getFacebookPages();
            }
        },

        getFacebookPages() {
            axios.get('/api/social-profiles/manager/facebook')
                .then((response) => {
                    this.facebook_pages = response.data;
                }).catch((error) => {
                    console.log(error);
                });
        },

        addSocialProfile() {
            this.loading = true;
            this.form.client_name = this.client.name;
            this.form.profile_label = this.getProfileLabel();
            this.form.token_id = this.getTokenId();
            let profile = this.form;

            this.$store.dispatch('client/addSocialProfile', {
                profile: profile
            })
            .then((response) => {
                Bus.$emit('show-success-alert', response.message);
                Bus.$emit('social-profile-added');
                this.reset();
            }).catch((error) => {
                console.log(error.data);
                this.loading = false;
            });

        },

        getProfileLabel() {
            if (this.form.vendor === 'Facebook') {
                return this.facebook_pages.filter((p) => p.id === this.form.profile_id)[0].name;
            }
            if (this.form.vendor === 'LinkedIn') {
                return this.form.profile_label;
            }
            return this.form.profile_id;
        },

        getTokenId() {
            switch (this.form.vendor) {
                case 'Facebook':
                    return 'facebook';
                    break;
                case 'LinkedIn':
                    return 'linkedin';
                    break;
                default:
                    return null;
            }
        },

        reset() {
            Object.assign(this.$data, this.$options.data());
        }
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/clients/NewSocialProfileForm.vue